import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=54551a3a&scoped=true&"
import script from "./Manual.vue?vue&type=script&lang=js&"
export * from "./Manual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54551a3a",
  null
  
)

export default component.exports